import axios from "axios";

export const baseUrl =
  process.env.REACT_APP_API_URL || "http://localhost:6093/";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getApiErrorMessage = (error, fallback) => {
  const responseData = error?.response?.data;
  return (
    responseData?.details?.details?.details?.error?.statusMessage ||
    responseData?.details?.details?.error?.statusMessage ||
    responseData?.details?.error?.statusMessage ||
    responseData?.message ||
    error?.message ||
    fallback
  );
};

export const getImagesApi = async () => {
  const response = await api.get("api/v1/get-images");
  return response;
};

export const getVideosApi = async () => {
  const response = await api.get("api/v1/get-videos");
  return response;
};

export const loginApi = async ({ msisdn }) => {
  const response = await api.post("api/login", { msisdn });
  return response.data;
};

export const getSubscriptionStatusApi = async ({ msisdn, packType }) => {
  const response = await api.get("api/subscription/status", {
    params: { msisdn, packType },
  });
  return response.data;
};

export const startSubscriptionApi = async ({ msisdn, packType }) => {
  const response = await api.post("api/subscription/start", {
    msisdn,
    packType,
  });
  return response.data;
};

export const getMySubscriptionApi = async (authToken) => {
  const response = await api.get("api/subscription/me", {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return response.data;
};

export const unsubscribeApi = async (authToken) => {
  const response = await api.post(
    "api/subscription/unsubscribe",
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return response.data;
};

export const PLANS = [
  {
    id: "DAILY",
    label: "Daily",
    amount: 50,
    serviceId: 49,
    vdlUrl:
      "http://mtn-nigeria-prod.mfilterit.org/sid/234012000025393/23401220000029795",
  },
  {
    id: "WEEKLY",
    label: "Weekly",
    amount: 100,
    serviceId: 51,
    vdlUrl:
      "http://mtn-nigeria-prod.mfilterit.org/sid/234012000025393/23401220000029796",
  },
];

export const AUTH_TOKEN_KEY = "kidsplex_auth_token";
export const AUTH_USER_KEY = "kidsplex_auth_user";
